import React from 'react';

const LoungeStatsTable = ({data}) => {
    return (
        <>
            <h3>Entradas por sala</h3>
            <table>
                <thead>
                    <tr>
                        <th>Sala</th>
                        <th>Entradas</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(({lounge: {name}, entries})=>
                              <tr key={name}>
                                  <th className='text-center'>
                                      {name}
                                  </th>
                                  <td className='text-right'>
                                      {entries}
                                  </td>
                              </tr>
                             )}
                </tbody>
            </table>
        </>
    );
};

export default LoungeStatsTable;
